module.exports = __webpack_public_path__ + "img/lobby_hosting_dpin.0b6b2c18.png";